export const consents = [
  {
    id: 'hasConsent1',
    href: `/files/legal/general_terms_and_conditions_{lang}.pdf`,
    label: 'WIZARD.SUMMARY.CONSENT_ONE',
    required: true,
  },
  {
    id: 'hasConsent2',
    href: `/files/legal/general_terms_and_conditions_{lang}.pdf`,
    label: 'WIZARD.SUMMARY.CONSENT_TWO',
    required: true,
  },
  {
    id: 'hasConsent3',
    label: 'WIZARD.SUMMARY.CONSENT_THREE',
    required: true,
  },
  {
    id: 'hasConsent4',
    label: 'WIZARD.SUMMARY.CONSENT_FOUR',
    required: false,
  },
  {
    id: 'hasConsent5',
    label: 'WIZARD.SUMMARY.CONSENT_FIVE',
    required: false,
  },
];
